import React from "react";
import styles from "../styles/HeroPage.module.css";

const HeroPage = () => (
  <div className={styles.page}>
    <main className={styles.main}>
      <h1 className={styles.name}>Mercy Mofoluwawo</h1>

      <div className={styles.bio}>
        <p>
          Mercy Mofoluwawo is a full-stack software engineer with five years of
          experience building and shipping technology products. She specialises
          in web development — from database architecture to polished interfaces
          — with a strong focus on travel tech.
        </p>
        <p>
          She built and launched a live travel platform, leading development
          end-to-end across the stack. She is passionate about creating software
          that is reliable, well-crafted, and genuinely useful to the people who
          use it.
        </p>
        <p>
          Mercy is currently open to new opportunities. She brings deep
          technical skill, a product mindset, and a track record of shipping
          things that hold up under real-world conditions.
        </p>
      </div>

      <div className={styles.links}>
        <a
          href="https://docs.google.com/document/d/1p4GNalpikG7dEBD7rmTR__lS41QY5RKhIJvKkOpirmo/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkItem}
        >
          Resume / CV
        </a>
        <div className={styles.socialRow}>
          <a
            href="https://www.linkedin.com/in/mercy-oyelude/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
          <span className={styles.pipe}>|</span>
          <a
            href="https://github.com/Mercy-Iyanu"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <span className={styles.pipe}>|</span>
          <a href="mailto:mmofoluwawo@gmail.com">mmofoluwawo@gmail.com</a>
        </div>
      </div>
    </main>
  </div>
);

export default HeroPage;
